import { ActionBar, ChakraBox, ChakraFlex } from '@equip.health/ui';

export const TreatmentOverviewCardErrorFallback = () => {
  return (
    <ChakraFlex
      borderColor="neutral.line"
      borderRadius="12px"
      borderWidth="1px"
      height="200"
      margin="18px"
      padding="18px"
      width="316px"
    >
      <ChakraBox>
        <ActionBar
          id="treatment-overview-card-error-fallback"
          text="We encountered an error loading treatment attributes."
          variant="critical"
        />
      </ChakraBox>
    </ChakraFlex>
  );
};
